import { IReportCategoryDefinition } from "pages/secure/shared/reports/reportCatalog.types";
import { reportEntry } from "pages/secure/shared/reports/reportCatalog.helpers";

export const facilityReportCatalog: IReportCategoryDefinition[] = [
  {
    id: "financial",
    title: "Financial",
    summary: "Receivables, reconciliation, accounting references, transactions.",
    icon: ["far", "money-bill"],
    reports: [
      reportEntry(
        "cash-reconciliation",
        "End-of-day cash drawer counts vs. recorded transactions.",
      ),
      reportEntry(
        "sales-by-accounting-reference",
        "Revenue grouped by GL reference code for export.",
      ),
      reportEntry(
        "transactions",
        "All POS transactions with filters, search, and export.",
      ),
      reportEntry(
        "golfnorth-daily-sales",
        "Daily sales summary formatted for GolfNorth corporate.",
        undefined,
        false,
      ),
      reportEntry("gl-golfnorth", "", undefined, false),
      reportEntry("accounts", "Customer accounts with balances and its status."),
      reportEntry("daily-sales", "Day-over-day sales summary across all departments."),
      reportEntry(
        "detailed-sales-by-department",
        "Line-item sales broken down by department and category.",
      ),
      reportEntry(
        "detailed-sales-and-inventory-by-department",
        "",
      ),
      reportEntry(
        "discounts",
        "",
      ),
      reportEntry(
        "form-responses",
        "Submitted responses for a selected form, filtered by date range.",
      ),
      reportEntry(
        "gift-card-activity",
        "",
      ),
      reportEntry(
        "gift-cards",
        "Gift card issuance, redemptions, and outstanding balances.",
      ),
      reportEntry(
        "hospitality-events",
        "Revenue and attendance summary for private and hosted events.",
      ),
      reportEntry(
        "item-sales-history",
        "Sales volume and revenue per item over a selected date range.",
      ),
      reportEntry(
        "leagues",
        "Leagues with start and end dates, player limits, and organizer details.",
      ),
      reportEntry(
        "server-summaries",
        "Sales, tips, voids, and average ticket per server by shift.",
      ),
      reportEntry(
        "sales-by-accounting-reference-standalone",
        "Revenue grouped by GL reference code with subtotal, quantity, and percent of sales.",
      ),
      reportEntry(
        "sales-by-department",
        "Revenue breakdown by department with category-level detail.",
      ),
      reportEntry(
        "tips-by-order",
        "Tip amounts recorded per order, filterable by date and server.",
      ),
      reportEntry(
        "cost-of-sales-by-department",
        "",
      ),
      reportEntry(
        "credit-books",
        "",
      ),
      reportEntry(
        "payouts",
        "Tee-On payout batches with gross/fee context for your pricing tier.",
      ),
      reportEntry(
        "processing-fee-transactions",
        "Per-transaction processing fees with IC++ platform and network cost breakdown.",
      ),
      reportEntry(
        "processing-fee-monthly-summary",
        "Monthly fee accrual summary for gross tiers — reconcile against Tee On invoices.",
      ),
      reportEntry(
        "compare-sales-by-date",
        "",
      ),
    ],
  },
  {
    id: "tee-sheet",
    title: "Tee Sheet",
    summary: "Tee sheet utilization, rounds by booking category, RevPAR, no-shows, and more.",
    icon: ["far", "golf-flag-hole"],
    reports: [
      reportEntry(
        "tee-sheet-utilization",
        "Booked vs. available tee times by day, hour, and customer type.",
      ),
      reportEntry(
        "tee-sheet-no-show",
        "Tee times marked no-show, with player history and lost-revenue.",
      ),
      reportEntry(
        "tee-sheet-overview",
        "First and last available tee times by day across the tee sheet.",
      ),
      reportEntry(
        "bookings",
        "Daily booking capacity showing booked, available, and total slots.",
      ),
      reportEntry(
        "bookings-by-source",
        "Daily booking and participant counts grouped by booking source.",
      ),
      reportEntry(
        "rounds-by-booking-category",
        "Booked rounds by booking category, split into 9 and 18 hole rounds.",
      ),
      reportEntry(
        "revpar",
        "Revenue per available round, with rounds played/booked and average rate metrics.",
      ),
      reportEntry(
        "tee-time-promotions",
        "Promotions and dynamic pricing applied to tee time bookings, with original, net, and savings.",
      ),
      reportEntry(
        "bag-storage-by-day",
        "",
      ),
      reportEntry(
        "booking-deposits",
        "",
      ),
      reportEntry(
        "cancelled-tee-time-orders",
        "",
      ),
      reportEntry(
        "rain-checks",
        "Rain checks by facility with status, customer, issued and redeemed dates.",
      ),
      reportEntry(
        "rounds-by-customer-type",
        "",
      ),
      reportEntry(
        "rounds-played-by-customer",
        "Rounds each customer played in a date range, with customer type and booking category filters.",
      ),
      reportEntry(
        "waitlist",
        "Customers on the waitlist by date, time, and course.",
      ),
    ],
  },
  {
    id: "inventory",
    title: "Inventory",
    summary: "Inventory listing by department, order exceptions.",
    icon: ["far", "box"],
    reports: [
      reportEntry(
        "inventory-listing-by-department",
        "Current stock-on-hand, value, and reorder by department.",
      ),
      reportEntry(
        "inventory-adjustments",
        "Stock adjustments with reason, quantity, and department.",
      ),
      reportEntry(
        "products",
        "",
      ),
      reportEntry(
        "outstanding-purchase-order-items",
        "View products that are currently on order or backordered from purchase orders.",
      ),
    ],
  },
  {
    id: "memberships",
    title: "Memberships",
    summary: "Member roster, member attrition, member visits + 1 more.",
    icon: ["far", "id-card"],
    reports: [
      reportEntry(
        "membership-sales",
        "New, renewed, upgraded, and lapsed membership revenue by tier.",
      ),
    ],
  },
  {
    id: "accounts",
    title: "Accounts",
    summary: "Receivables, adjustments, and account activity.",
    icon: ["far", "wallet"],
    reports: [
      reportEntry(
        "aged-accounts-receivable",
        "Outstanding member balances bucketed by 30/60/90+ days.",
      ),
      reportEntry(
        "accounts-receivable",
        "Outstanding balances with total amounts owed by customer.",
      ),
      reportEntry(
        "golfnorth-invoice-daily-sales",
        "Daily invoice summary formatted for GolfNorth corporate.",
      ),
      reportEntry(
        "scheduled-payments",
        "Upcoming auto-billed payments by member account.",
      ),
      reportEntry(
        "account-activity",
        "",
      ),
      reportEntry(
        "email-activity",
        "",
      ),
    ],
  },
  {
    id: "credit-books",
    title: "Credit Books",
    summary: "Prize accounts and credit book balances.",
    icon: ["far", "book"],
    reports: [
      reportEntry(
        "prize-accounts",
        "Prize account balances.",
      ),
      reportEntry(
        "credit-books",
        "Credit book balances by member account.",
      ),
      reportEntry(
        "credit-book-transactions",
        "Credit book and prize account transactions by date range.",
      ),
    ],
  },
  {
    id: "invoices",
    title: "Invoices",
    summary: "Deposits and member invoices.",
    icon: ["far", "file-invoice"],
    reports: [
      reportEntry(
        "deposits",
        "Summary of records with status, amount, and reconciliation reference.",
      ),
      reportEntry(
        "invoices",
        "Outstanding and paid invoices with due dates and payment history.",
      ),
    ],
  },
  {
    id: "orders",
    title: "Orders",
    summary: "Order history and purchase exceptions.",
    icon: ["far", "receipt"],
    reports: [
      reportEntry(
        "order-exceptions",
        "Purchase orders, price mismatch, or missing receipt.",
      ),
      reportEntry(
        "orders",
        "All customer orders with status, items, and fulfillment detail.",
      ),
      reportEntry(
        "loyalty-program-redemptions",
        "View loyalty program redemptions on orders",
      ),
    ],
  },
  {
    id: "staff",
    title: "Staff",
    summary: "Staff shift history and account activity.",
    icon: ["far", "user-clock"],
    reports: [
      reportEntry(
        "staff-account-shifts",
        "Shift-level summary of staff sales, tips, and hours worked.",
      ),
    ],
  },
  {
    id: "tickets",
    title: "Tickets",
    summary: "Ticket sales, redemptions, and activity.",
    icon: ["far", "ticket"],
    reports: [
      reportEntry(
        "tickets-redeemed",
        "Redeemed ticket log with player, date, rate, and redemption type.",
      ),
      reportEntry(
        "ticket-overview",
        "",
      ),
      reportEntry(
        "tickets",
        "",
      ),
      reportEntry(
        "tickets-expired",
        "",
      ),
    ],
  },
  {
    id: "tournaments",
    title: "Tournaments",
    summary: "Tournaments, leagues, hospitality events, and form responses.",
    icon: ["far", "trophy"],
    reports: [
      reportEntry(
        "tournaments",
        "Tournaments with start and end dates, registrations and organizer details.",
      ),
      reportEntry(
        "events-not-invoiced",
        "Tournaments with outstanding or missing invoice records.",
      ),
      reportEntry(
        "hospitality-events-not-invoiced",
        "",
      ),
    ],
  },
  {
    id: "customer",
    title: "Customer",
    summary: "Customer related reports",
    icon: ["far", "user"],
    reports: [
      reportEntry(
        "loyalty-program-points-balance",
        "View each customer's loyalty points balance as of a selected date.",
      ),
      reportEntry(
        "customers-created",
        "Customers added in a selected date range, based on when their customer record was created. Filter by customer type.",
      ),
    ],
  },
];
